// `respostas`/`perguntas` são sempre substituídos por um objeto/array NOVO (nunca
// `state.respostas[campo] = valor` em cima do que já existia) — é o que faz a
// reatividade do Vue 2 funcionar sem precisar de `Vue.set` aqui: a chave de topo
// (`state.respostas`) já é reativa desde a fábrica de `state.js`, e trocar seu VALOR
// por um objeto novo propaga normalmente. `Vue.set` só seria necessário se
// adicionássemos uma chave nova a um objeto reativo já existente sem substituí-lo
// inteiro — o que este módulo nunca faz, de propósito: o servidor é a fonte única do
// que foi respondido (AC-2.4), o cliente nunca faz merge incremental por cima.

// Aplica o `value` do envelope (GET/PUT/POST) — NUNCA toca `rascunho`, `loading`,
// `enviando` ou `erro`: são estado da TELA, não do servidor. É esta separação que
// garante não perder o que está sendo digitado quando um 409 dispara um re-fetch
// (T013: test_409_relê_sem_perder_digitacao).
export const SET_ESTADO = (state, value) => {
  if (!value) return

  state.campoAtual = value.campo_atual || null
  state.respostas = value.respostas || {}
  state.revisao = value.revisao || 0
  state.posicao = value.posicao !== undefined ? value.posicao : null
  state.concluido = !!value.concluido
  state.perguntas = value.perguntas || []
  // ★ O agrupamento vem inteiro do servidor. Ausente = lista vazia, e a tela mostra
  // que não há etapa — nunca uma lista escrita no front (contracts/etapas-do-questionario.md).
  state.etapas = value.etapas || []
  state.etapaAtual = value.etapa_atual || null
}

// Grava a digitação em curso de UM campo. Substitui o objeto inteiro (não muta a chave
// em cima do que existia): o Vue 2 detecta a reatribuição sem `Vue.set`, e isso vale
// mesmo para um campo que ainda não estava no mapa — que é sempre o caso na primeira
// tecla de cada pergunta.
export const SET_RASCUNHO = (state, payload) => {
  if (!payload || !payload.campo) return

  const proximo = { ...state.rascunho }
  proximo[payload.campo] = payload.valor || ''
  state.rascunho = proximo
}

// Descarta o rascunho do que já foi CONFIRMADO pelo servidor. Sem lista, limpa tudo
// (é o caso do "Refazer", que recomeça o questionário).
//
// ⚠️ Por campo, e não tudo de uma vez, porque a etapa grava um campo por PUT em
// SEQUÊNCIA: limpar o mapa inteiro no primeiro 200 apagaria a digitação dos campos
// que ainda nem foram enviados.
export const LIMPAR_RASCUNHO = (state, campos) => {
  if (!campos) {
    state.rascunho = {}
    return
  }

  const lista = Array.isArray(campos) ? campos : [campos]
  const proximo = { ...state.rascunho }
  lista.forEach((campo) => {
    delete proximo[campo]
  })
  state.rascunho = proximo
}

export const SET_LOADING = (state, payload) => {
  state.loading = !!payload
}

export const SET_ENVIANDO = (state, payload) => {
  state.enviando = !!payload
}

export const SET_ERRO = (state, mensagem) => {
  state.erro = mensagem || null
}
